import { render, staticRenderFns } from "./BlogSettings.vue?vue&type=template&id=efa3ef88"
import script from "./BlogSettings.vue?vue&type=script&lang=js"
export * from "./BlogSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports